import React, { useEffect } from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { Link, withRouter } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Moment from 'react-moment';
import Layout from '@components/Layout/Layout';
import Card from '@components/Card/Card';
import OfferCard from '@themes/4/components/Offer/OfferCard';
import { startSetOfferNews } from '@actions/offers';
import CreateFlowPage from '@pages/flows/CreateFlowPage/CreateFlowPage';
import OfferTargetAudience from '../../components/Offer/OfferTargetAudience';
import OfferStats from '@components/Offer/OfferStats';
import OfferGeoPrices from '@components/Offer/OfferGeoPrices';
import OfferApprove from '@components/Offer/OfferApprove';
import OfferTopLink from '@components/Offer/OfferTopLink';
import LandingRequest from '../../../../components/LandingRequest/LandingRequest';
import OfferLandings from '../../../../components/Offer/OfferLandings';
import OfferNews from '../../../../components/Offer/OfferNews';
import DialogModal from '../../../../modals/DialogModal/DialogModal';
import OfferPixels from '../../../../components/Offer/OfferPixels';
import OfferFiles from '../../../../components/Offer/OfferFiles';
import OfferForbiddenGeoList from '../../../../components/Offer/OfferForbiddenGeoList';
import OfferSources from '../../../../components/Offer/OfferSources';
import OfferGeoList from '../../../../components/Offer/OfferGeoList';
import OfferPostClick from '../../../../components/Offer/OfferPostClick';
import OfferSupportHours from '../../../../components/Offer/OfferSupportHours';

const OfferPage = ({
  data: {
    offer,
    sources,
    offerSettings,
    countries,
    site_key,
    profile,
    loading,
    offerHasFlowsModalOpen,
    confirmModal,
    editFlow,
    children,
  },
  baseCurrency,
  topBundle,
  onRequestOfferAccess,
  onRefuseOfferAccess,
  handleFlowCreate,
  renderAlertModal,
  handleModal,
  toggleModal,
  offerHasFlowsModalToggle,
  history,
  match,
}) => {
  const dispatch = useDispatch();
  const offerNews = useSelector(state => state.offers.news);
  useEffect(() => {
    if (offer.id) {
      dispatch(startSetOfferNews(offer.id));
    }
  }, [offer.id]);

  const getOfferStartDate = (news = []) => {
    const firstNews = news[news.length - 1];
    if (firstNews && firstNews.its) {
      return (
        <Moment format="DD.MM.YYYY" unix>
          {firstNews.its}
        </Moment>
      );
    }
    return null;
  };

  const offerStartDate = getOfferStartDate(offerNews);

  return (
    <Layout title={offer.title} className="offer-page">
      <Layout.LeftCol md="12" className="left-col">
        <Card className="card-loading-silent" loading={loading}>
          <Card.Header>
            <Breadcrumb>
              <BreadcrumbItem>
                <Link to="/offers/all">
                  <FormattedMessage id="offers.breadcrumb" defaultMessage="All offers" />
                </Link>
              </BreadcrumbItem>
              <BreadcrumbItem>{offer.title}</BreadcrumbItem>
            </Breadcrumb>
          </Card.Header>

          {offer.id && (
            <Card.Body>
              <OfferCard
                editFlow={editFlow}
                offerSettings={offerSettings}
                onRequestOfferAccess={onRequestOfferAccess}
                onRefuseOfferAccess={onRefuseOfferAccess}
                onFlowCreate={handleFlowCreate}
                offer={offer}
              />
            </Card.Body>
          )}
        </Card>
        {editFlow ? (
          children
        ) : offer.modifies.is_my ? (
          <CreateFlowPage
            offerFromPage={offer}
            history={history}
            match={match}
            location={history.location}
          />
        ) : (
          <>
            {offer.id && offer.modifies.is_cdn && <LandingRequest offerId={offer.id} />}
            {baseCurrency && offer.landings && offer.landings.length > 0 && (
              <OfferLandings
                landings={offer.landings}
                currency={baseCurrency}
                offer={offer}
                site_key={site_key}
                connectOffer={onRequestOfferAccess}
                topItem={topBundle.best_landing}
              />
            )}
            {baseCurrency && offer.transits && offer.transits.length > 0 && (
              <OfferLandings
                name="prelanders"
                landings={offer.transits}
                currency={baseCurrency}
                offer={offer}
                site_key={site_key}
                connectOffer={onRequestOfferAccess}
                topItem={topBundle.best_prelanding}
              />
            )}
            {offer.id && <OfferNews offerId={offer.id} />}
          </>
        )}
      </Layout.LeftCol>
      <Layout.RightCol md="12" className="right-col offer-additional-info">
        {offerStartDate && (
          <div className="offer-start-date col-12 py-3">
            <FormattedMessage
              id="offer.start_data.title"
              defaultMessage="Launch date: {date}"
              values={{
                date: offerStartDate,
              }}
            />
          </div>
        )}

        {offer.pixels && offer.pixels.length > 0 && (
          <OfferPixels
            theme={4}
            withLink
            withoutControls
            collapsing
            pixels={offer.pixels}
            offerId={offer.id}
            isCdn={offer.modifies.is_cdn}
            coins={offer.modifies.coins}
            countries={countries}
            offer_geo={offer.offer_geo}
            geos={offer.geo}
          />
        )}

        {/* OFFERRUM-1577 */}
        {/* {offer.offer_geo !== undefined && offer.offer_geo !== null && offer.modifies.is_cdn && (
          <OfferGeoPrices
            collapsing
            withoutControls
            items={offer.offer_geo}
            countries={countries}
            offerId={offer.id}
          />
        )} */}

        {offer.id && <OfferSupportHours offerId={offer.id} collapsing />}

        {offer.stats && offer.stats.length > 0 && offer.top_bundle && (
          <Card collapsing>
            <Card.Header>Средний процент подтверждения</Card.Header>
            <Card.Body className="no-padding">
              <OfferApprove position={'left'} withoutHeader stats={offer.stats} />
              <OfferTopLink
                theme={4}
                item={offer.top_bundle}
                offer={offer}
                onClick={onRequestOfferAccess}
                inOfferPage
              />
            </Card.Body>
          </Card>
        )}

        {offer.forbiddenGeo && offer.forbiddenGeo.length > 0 && !offer.modifies.is_cdn && (
          <OfferForbiddenGeoList theme={4} collapsing countries={offer.forbiddenGeo} />
        )}
        {offer.offerStatsYandex && offer.offerStatsYandex.stats && (
          <OfferTargetAudience
            type="demography"
            theme={4}
            audience={offer.offerStatsYandex.stats}
            profile={profile}
          />
        )}
        {offer.offerStatsYandex && offer.offerStatsYandex.stats && (
          <OfferTargetAudience
            type="sources & countries"
            theme={4}
            audience={offer.offerStatsYandex.stats}
            profile={profile}
          />
        )}
        {offer.stats && !offer.modifies.g && (
          <OfferStats collapsing statistics={offer.stats} currency={baseCurrency} />
        )}
        {offer.sources && offer.sources.length > 0 && (
          <OfferSources
            collapsing
            sources={sources}
            selected={offer.sources}
            invert={offer.sources_inversion}
            prefix={offer.prefix}
          />
        )}

        {offer.countriesList && !offer.modifies.is_cdn && (
          <OfferGeoList
            collapsing
            withoutControls
            countries={offer.countriesList}
            offerId={offer.id}
            forbiddenGeo={offer.forbiddenGeo}
          />
        )}

        {/* {offer.stats && offer.stats.length > 0 && (
          <OfferApprove collapsing position={'left'} stats={offer.stats} />
        )}
        {offer.top_bundle && (
          <OfferTopLink
            item={offer.top_bundle}
            offer={offer}
            onClick={onRequestOfferAccess}
            inOfferPage
          />
        )} */}

        {offer.files && offer.files.length > 0 && <OfferFiles collapsing files={offer.files} />}

        {/* {offer.expire !== undefined && <OfferPostClick hold={offer.expire} />} */}
      </Layout.RightCol>
      <DialogModal
        open={confirmModal}
        onConfirm={handleModal}
        onCancel={toggleModal}
        message={<FormattedMessage id="offer.modal.remove" defaultMessage="Remove offer" />}
      />
      {renderAlertModal()}
    </Layout>
  );
};

export default withRouter(OfferPage);
